import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/TechTrendsClient.tsx");
